var map = {
	"./favicon-32x32.png": 574,
	"./icon-menu-close.svg": 6451,
	"./icon-menu.svg": 636,
	"./image-gaming-growth.jpg": 8002,
	"./image-retro-pcs.jpg": 158,
	"./image-top-laptops.jpg": 4262,
	"./image-web-3-desktop.jpg": 4074,
	"./image-web-3-mobile.jpg": 3030,
	"./logo.svg": 3914
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;